import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvOrganizationPickerComponent } from '../../../../Shared/Components/av-organization-picker/av-organization-picker.component';
import { AuditLogFacade } from '../../../../../Facades/Ops/audit-log.facade';
import { DATE_TIME_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { AuditLogFilters } from '../../../../../Interfaces/api/backoffice/audit-log.interface';

@Component({
  selector: 'app-audit-log',
  standalone: true,
  imports: [
    DatePipe,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvOrganizationPickerComponent,
  ],
  templateUrl: './audit-log.component.html',
  styleUrl: './audit-log.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class AuditLogComponent {
  readonly facade = inject(AuditLogFacade);

  readonly dateTimeFormat = DATE_TIME_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;

  readonly isEmpty = computed<boolean>(
    () => this.facade.state() === 'ready' && this.facade.entries().length === 0,
  );

  changeFilter(field: keyof AuditLogFilters, value: string): void {
    this.facade.applyFilters({ ...this.facade.filters(), [field]: value });
  }

  clearFilters(): void {
    this.facade.clearFilters();
  }

  toggleEntry(entryId: string): void {
    this.facade.toggleEntry(entryId);
  }

  goToPage(page: number): void {
    this.facade.goToPage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }

  reload(): void {
    this.facade.reload();
  }
}
